import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const moveToNewSectionTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  exit: assign<Context>({
    selectedLessonId: null,
    selectedSectionId: null
  }),
  invoke: {
    src: "moveItemToNewSection",
    onDone: {
      target: "#StudyPlan.edit_plan.reorder_mode.idle",
      actions: assign({ studyPlan: (_ctx, evt) => evt.data.plan })
    },
    onError: {
      //target: "#StudyPlan.edit_plan.reorder_mode.idle",
      target: "#StudyPlan.edit_plan.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("moveItemToNewSection", {
            errorReason: evt.data.message,
            messageData: ["move item to section"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
